import { render, staticRenderFns } from "./UnidadeMedidaCadastro.vue?vue&type=template&id=b10c2e04&scoped=true&lang=html"
import script from "./UnidadeMedidaCadastro.vue?vue&type=script&lang=js"
export * from "./UnidadeMedidaCadastro.vue?vue&type=script&lang=js"
import style0 from "./UnidadeMedidaCadastro.vue?vue&type=style&index=0&id=b10c2e04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b10c2e04",
  null
  
)

export default component.exports